import React, { ReactNode, useEffect, useState } from "react";
import DeviceContext from "./customHooks/indentifyDevice";
export interface IFloatButton {
  children?: ReactNode;
  parentClass: string;
  listClass?: string;
  closeButton?: boolean;
  dropdownList: boolean;
  onClick?: Function;
  icon: React.ReactElement;
  closeIcon?: React.ReactElement;
  closeDropdown?: () => void;
  iconWihoutHop?: React.ReactElement;
}
const FloatButton = (props: IFloatButton) => {
  const [open, setOpen] = useState<boolean>(false);
  const device = DeviceContext();
  const [scrolled, setScrolled] = useState(false);
  // useEffect(() => {
  //   const app = document.getElementsByClassName("mob-page")[0];
  //   console.log(app);

  //   if (app) {
  //     if (open) {
  //       app.classList.add("blur");
  //     } else {
  //       app.classList.remove("blur");
  //     }
  //   }
  // }, [open]);
  // console.log("first", !open || !scrolled);
  // console.log("second", !scrolled);
  // console.log("third", !open);
  const handleItemClick = () => {
    if (props.closeDropdown) {
      props.closeDropdown();
      setOpen(!open);
    }
  };
  React.useEffect(() => {
    const handleScroll = () => {
      setScrolled(() => {
        if (device?.isDesktop) return window.scrollY > 500 ? true : false;
        return window.scrollY > 200 ? true : false;
      });
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  // const element = document.getElementById("ymPluginDivContainerInitial");
  return (
    <div
      className={`${open ? "blur" : "non-blur"} ${
        scrolled ? "hopBtnBorder-scrolled" : ""
      }`}
    >
      <div
        className={`btn-group btn-group-lg dropup floating-action-button ${
          props.dropdownList && open ? "open" : ""
        } ${props.parentClass}`}
        // onBlur={() => setOpen(false)}
      >
        <button
          type="button"
          className={`btn btn-info btn-fab btn-raised dropdown-toggle  ${
            !open ? "hopBtnBorder" : "hop-float-button"
          }`}
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded={open}
          onClick={() => {
            if (props.dropdownList) setOpen(!open);
            else props.onClick();
          }}
        >
          {!open && (!scrolled ? props.icon : props.iconWihoutHop)}
          {open && props.dropdownList && open && props.closeIcon}
        </button>

        {props.dropdownList && (
          <ul
            className={`dropdown-menu dropdown-menu-left ${props.listClass}`}
            onClick={handleItemClick}
          >
            {/* <li className="listHead">
              <div className="d-flex align-items-center ">
                <i className="dotBlue"></i>
                <p>Market Mood Indicator</p>
              </div>
            </li> */}
            {props.closeButton && (
              <li>
                <a href="#" className="btn btn-danger btn-fab btn-raised">
                  <i className="material-icons">clear</i>
                </a>
              </li>
            )}
            {props.children}
          </ul>
        )}
      </div>
    </div>
  );
};

export default FloatButton;
